/**
 * Triggers the browser print dialog for the given Blob by loading it into a hidden iframe.
 *
 * @param blob - The Blob object to be printed.
 * @param onComplete - Optional callback invoked after the print dialog is triggered.
 */
export function printBlob(blob: Blob, onComplete?: () => void) {
  const blobUrl = URL.createObjectURL(blob)
  const iframe = document.createElement('iframe')

  iframe.style.display = 'none'
  iframe.src = blobUrl

  iframe.onload = () => {
    iframe.contentWindow?.focus()
    iframe.contentWindow?.print()
    URL.revokeObjectURL(blobUrl)
    onComplete?.()
  }

  iframe.onerror = () => {
    URL.revokeObjectURL(blobUrl)
  }

  document.body.appendChild(iframe)
}
